<template>
  <v-form ref="form">
    <v-container class="custom-container">
      <v-overlay :value="isLoading" absolute>
        <v-progress-circular indeterminate size="44"></v-progress-circular>
      </v-overlay>
      <v-dialog v-model="showDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline">We have a winniner!</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" text @click="closeDialog">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showNoWinningsDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline"
            >No winnings. Best of luck next time.</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeNoWinningsDialog"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row v-if="!isLoading" align="center" justify="center">
        <v-col cols="12">
          <v-card class="card mt-6" dark>
            <div v-if="!getSecond">
              <v-row class="MainComponent">
                <!-- <v-col
                  cols="7"
                  v-for="product in getProductsForSale"
                  :key="product.id + product.doublePrice"
                  :style="{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '6px',
                  }"
                  ><span class="titleSpan">{{
                    product.productTemplateDto.title
                  }}</span>
                </v-col> -->
                <v-col
                  cols="7"
                  :style="{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '6px',
                  }"
                  v-if="selectedSchedule > 0"
                >
                  <span class="titleSpan">
                    {{
                      selectedSchedule
                        ? selectedSchedule.title
                        : product.productTemplateDto.title
                    }}
                  </span>
                </v-col>
              </v-row>
              <v-row :style="{ margin: '10px 16px 10px 10px' }">
                <v-col
                  class="billBlockMain"
                  cols="12"
                  md="7"
                  v-if="selectedSchedule && !proceed"
                >
                  <div class="productDetailMain">
                    <div>
                      <div>
                        <v-col cols="12" class="posDropdown">
                          <v-autocomplete
                            class="pb-2  gameDropdown"
                            :clearable="false"
                            :persistent-hint="true"
                            solo
                            light
                            hide-details
                            auto-select-first
                            :label="'Select Game'"
                            v-model="selectedSchedule"
                            :items="getScheduleList"
                            :item-value="(obj) => obj"
                            :item-text="(obj) => obj.title + ' - ' + obj.date"
                            append-icon=""
                          ></v-autocomplete>
                        </v-col>
                      </div>

                      <div
                        v-if="
                          getProductsForSale.length === 1 &&
                            !getProductsForSale[0].productTemplateDto.packaged
                        "
                        class="logoBox logoBoxPOS"
                        :class="{
                          'selected-game':
                            selectedGames[getProductsForSale[0].id],
                        }"
                        @click="toggleGameSelection(getProductsForSale[0])"
                      >
                        <div class="gameInfo">
                          <span class="gameName">{{
                            getProductsForSale[0].productTemplateDto.title
                          }}</span>
                          <span class="gamePrice">
                            €{{ (getProductsForSale[0].price || 0).toFixed(2) }}
                          </span>
                        </div>
                        <img
                          :src="
                            'data:image/jpeg;base64,' +
                              getProductsForSale[0].productTemplateDto.logo
                          "
                          class="absolute-center logoImage"
                        />
                      </div>
                      <v-col v-else cols="12" class="productLogos">
                        <div class="products-grid">
                          <div
                            v-for="(product, index) in orderedProducts"
                            :key="'product-' + index"
                            class="productCard"
                          >
                            <div
                              class="logoBox logoBoxPOS"
                              :class="{
                                'selected-game': selectedGames[product.id],
                              }"
                              @click="toggleGameSelection(product)"
                            >
                              <div class="gameInfo">
                                <span class="gameName">{{
                                  product.productTemplateDto.title
                                }}</span>
                                <span class="gamePrice">
                                  €{{ (product.price || 0).toFixed(2) }}
                                </span>
                              </div>
                              <div class="gameCardBase">
                                <img
                                  :src="
                                    'data:image/jpeg;base64,' +
                                      product.productTemplateDto.logo
                                  "
                                  class="absolute-center logoImage"
                                  :alt="product.productTemplateDto.title"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <div class="logoBoxMain">
                        <v-col
                          cols="12"
                          md="6"
                          class="logoBoxValue"
                          :style="{ flexDirection: 'column' }"
                        >
                          <span class="ticketPriceSpan"
                            >Total Ticket’s Price
                          </span>
                          <span
                            :style="{ padding: '10px 0px 10px 0px' }"
                            class="ticketPriceSpanNumber gameTicketPrice"
                          >
                            €{{ calculateTotalPrice() }}
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                          :style="{
                            padding: '0px',
                          }"
                        >
                          <div
                            class="logoBox marginBox"
                            :style="{
                              padding: '15px',
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'start',
                            }"
                          >
                            <v-col
                              cols="12"
                              class="totalDueAmountCol newDisplay"
                              ><span
                                class="ticketPriceSpan
                            "
                              >
                                Due Amount
                              </span>
                              <span
                                class="ticketPriceSpanNumber gameTicketPrice
                            "
                                >€{{ totalAmount }}</span
                              ></v-col
                            >
                          </div>
                        </v-col>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" md="12">
                        <div class="logoBox marginBox">
                          <v-autocomplete
                            class="mt-2 mb-2"
                            hide-details
                            v-if="selectedSchedule && !getSecond"
                            :return-object="false"
                            v-model="selectedCustomer"
                            :items="getCustomerList"
                            clearable
                            :persistent-hint="true"
                            solo
                            light
                            :item-text="
                              (obj) =>
                                obj.displayName +
                                ', ' +
                                obj.firstName +
                                ' ' +
                                obj.lastName +
                                ', ' +
                                obj.email +
                                ', ' +
                                obj.barCodeId
                            "
                            :item-value="(obj) => obj"
                            :label="'Find a customer'"
                          ></v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                  class="receitBlock"
                  :style="{ padding: '0px' }"
                >
                  <v-col
                    cols="12"
                    class="receitBox"
                    :style="{ flexDirection: 'column' }"
                  >
                    <span class="saleText">Sale Receipt</span>

                    <div class="receitSection" v-if="receitSections.length > 0">
                      <div class="gameBox">
                        <div class="gameDate">
                          <span>{{ formattedDate }}</span>
                        </div>
                        <span class="gameText">{{
                          selectedScheduleTitle
                        }}</span>
                        <span>Full Time</span>

                        <div class="tableBox">
                          <div class="tableRow header">
                            <span>Qty</span>
                            <span class="nameColumnHeader">Item</span>
                            <span>Price</span>
                            <span>Total</span>
                            <span>Action</span>
                          </div>

                          <div
                            class="tableRow contentRow"
                            v-for="(item, index) in allReceiptItems"
                            :key="index"
                          >
                            <div class="qtyBox">
                              <span
                                class="qtyInput receitQuantityspan"
                                contenteditable="true"
                                @keydown="handleQuantityKeydown($event, item)"
                                @blur="validateReceiptQuantity($event, item)"
                                :key="
                                  'quantity-' +
                                    item.sectionId +
                                    '-' +
                                    item.itemIndex
                                "
                              >
                                {{ item.quantity }}
                              </span>
                              <div class="icons">
                                <button
                                  type="button"
                                  class="plusBtn"
                                  @click="
                                    increaseQuantity(
                                      item.sectionId,
                                      item.itemIndex
                                    )
                                  "
                                >
                                  <img
                                    src="../../assets/plus-icon.svg"
                                    alt="plus"
                                  />
                                </button>
                                <button
                                  type="button"
                                  class="minusBtn"
                                  @click="
                                    decreaseQuantity(
                                      item.sectionId,
                                      item.itemIndex
                                    )
                                  "
                                >
                                  <img
                                    src="../../assets/minus-icon.svg"
                                    alt="minus"
                                  />
                                </button>
                              </div>
                            </div>
                            <span class="nameColumn">{{ item.game }}</span>
                            <span class="priceBox"
                              >€{{ item.unitPrice.toFixed(2) }}</span
                            >
                            <span class="priceBox"
                              >€{{ item.price.toFixed(2) }}</span
                            >
                            <span
                              class="receitdeleteBtn"
                              @click="
                                deleteReceitItem(item.sectionId, item.itemIndex)
                              "
                            >
                              <img
                                src="../../assets/delete-bin.svg"
                                alt="delete"
                              />
                            </span>
                          </div>
                          <div
                            v-if="showCheckoutLimitWarning"
                            class="limitWarning"
                          >
                            Maximum limit of {{ maxItems }} items reached!
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
              <v-row class="btnsRow">
                <v-col cols="12" md="7"> </v-col>
                <v-col cols="12" md="5">
                  <div class="subTotalColumn" :style="{ padding: '1px' }">
                    <button
                      type="button"
                      class="subTotalBtn"
                      @click="showSecond"
                    >
                      Subtotal
                    </button>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div v-if="getSecond" class="calculatorBox" :key="componentKey">
              <v-row class="posSectionRow">
                <v-col cols="12" md="6" class="receitBlock receitBlockSecond">
                  <v-col
                    cols="12"
                    class="receitBox receitBoxSecond"
                    :style="{ flexDirection: 'column' }"
                  >
                    <span class="saleText">Sale Receipt</span>

                    <div class="receitSection" v-if="receitSections.length > 0">
                      <div class="gameBox">
                        <div class="gameDate">
                          <span>{{ formattedDate }}</span>
                        </div>
                        <span class="gameText">{{
                          selectedScheduleTitle
                        }}</span>
                        <span>Full Time</span>

                        <div class="tableBox">
                          <div class="tableRow header">
                            <span>Qty</span>
                            <span class="nameColumnHeader">Item</span>
                            <span>Price</span>
                            <span>Total</span>
                            <span>Action</span>
                          </div>

                          <div
                            class="tableRow contentRow"
                            v-for="(item, index) in allReceiptItems"
                            :key="index"
                          >
                            <div class="qtyBox">
                              <span
                                class="qtyInput receitQuantityspan"
                                contenteditable="true"
                                @keydown="handleQuantityKeydown($event, item)"
                                @blur="validateReceiptQuantity($event, item)"
                                :key="
                                  'quantity-' +
                                    item.sectionId +
                                    '-' +
                                    item.itemIndex
                                "
                              >
                                {{ item.quantity }}
                              </span>
                              <div class="icons">
                                <button
                                  type="button"
                                  class="plusBtn"
                                  @click="
                                    increaseQuantity(
                                      item.sectionId,
                                      item.itemIndex
                                    )
                                  "
                                >
                                  <img
                                    src="../../assets/plus-icon.svg"
                                    alt="plus"
                                  />
                                </button>
                                <button
                                  type="button"
                                  class="minusBtn"
                                  @click="
                                    decreaseQuantity(
                                      item.sectionId,
                                      item.itemIndex
                                    )
                                  "
                                >
                                  <img
                                    src="../../assets/minus-icon.svg"
                                    alt="minus"
                                  />
                                </button>
                              </div>
                            </div>
                            <span class="nameColumn">{{ item.game }}</span>
                            <span class="priceBox"
                              >€{{ item.unitPrice.toFixed(2) }}</span
                            >
                            <span class="priceBox"
                              >€{{ item.price.toFixed(2) }}</span
                            >
                            <span
                              class="receitdeleteBtn"
                              @click="
                                deleteReceitItem(item.sectionId, item.itemIndex)
                              "
                            >
                              <img
                                src="../../assets/delete-bin.svg"
                                alt="delete"
                              />
                            </span>
                          </div>
                          <div
                            v-if="showCheckoutLimitWarning"
                            class="limitWarning"
                          >
                            Maximum limit of {{ maxItems }} items reached!
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-col>
                <v-col
                  class="calculatorSection"
                  cols="12"
                  md="6"
                  :style="{ padding: '0px' }"
                >
                  <div class="displayAmountRow">
                    <v-col cols="12" md="6" class="totalAmountdisplay">
                      <span class="totalTitle">Amount Received</span>
                      <span class="priceAmount">{{ cashTendered }}</span>
                    </v-col>
                    <v-col cols="12" md="6" class="totalAmountdisplay">
                      <span class="totalTitle">Change Due:</span>
                      <span class="priceAmount"> {{ AmountDue }}</span>
                    </v-col>
                  </div>

                  <v-col class="logoBoxCal">
                    <v-col class="cashCal">
                      {{ cashTendered }}
                      <hr />
                    </v-col>

                    <div>
                      <div class="pt-3" :style="{ display: 'flex' }">
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('7')"
                            >7</v-btn
                          >
                        </v-col>
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('8')"
                            >8</v-btn
                          >
                        </v-col>
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('9')"
                            >9</v-btn
                          >
                        </v-col>
                      </div>
                      <div :style="{ display: 'flex' }">
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('4')"
                            >4</v-btn
                          >
                        </v-col>
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('5')"
                            >5</v-btn
                          >
                        </v-col>
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('6')"
                            >6</v-btn
                          >
                        </v-col>
                      </div>
                      <div :style="{ display: 'flex' }">
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('1')"
                            >1</v-btn
                          >
                        </v-col>
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('2')"
                            >2</v-btn
                          >
                        </v-col>
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('3')"
                            >3</v-btn
                          >
                        </v-col>
                      </div>
                      <div :style="{ display: 'flex' }">
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('.')"
                            >.</v-btn
                          >
                        </v-col>
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('0')"
                            >0</v-btn
                          >
                        </v-col>
                        <v-col cols="4" :style="{ padding: '5px' }">
                          <v-btn class="calBtn" @click="keyPadEvent('DEL')"
                            ><img src="../../assets/eyes.svg" alt="eyes"
                          /></v-btn>
                        </v-col>
                      </div>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" class="totalColumnRow">
                  <div class="totalAmountColumn">
                    <span class="totalTitle"> Total Amount:</span>
                    <span>€{{ totalAmount }}</span>
                  </div>
                </v-col>
                <v-col class="btnsGroup" cols="12" md="6">
                  <button type="button" class="clearBtn" @click="clear">
                    CLEAR
                  </button>
                  <button
                    class="completeBtn"
                    @click.prevent="proceedToSale()"
                    :disabled="isProcessing || receitSections.length === 0"
                  >
                    {{ isProcessing ? "Processing..." : "COMPLETE" }}
                  </button>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div id="printMe"></div>
  </v-form>
</template>

<script>
import CONST from "@/const/index.js";
import { mapActions, mapGetters } from "vuex";
import ENDPOINTS from "@/api/endpoints/bingoManager-core/endpoints.js";
import { EventBus } from "@/main";
import printJS from "print-js";
export default {
  name: "PointOfSale",
  created() {
    this.fetchUpcoming();
    this.fetchCustomers();
    EventBus.$on("BARCODE_SCANNED", (data) => {
      this.onDecode(data);
    });
  },
  destroyed: function() {},
  directives: {
    print,
  },
  data() {
    return {
      receiptId: null,
      isLoading: true,
      showLimitWarning: false,
      showCheckoutLimitWarning: false,
      maxItems: 10,
      processedItems: [],
      receitSections: [],
      selectedGames: {},
      proceedsecondComponent: false,
      isProcessing: false,
      selectedSchedule: null,
      selectedCustomer: null,
      items: [],
      products: [],
      books: [],
      booksInPackage: [],
      booksNotInPackage: [],
      amountTendered: "",
      proceed: false,
      pay: false,
      bookInput: null,
      showDialog: false,
      showNoWinningsDialog: false,
      value: "",
      show: 1,
      number: 0,
      cartItems: [],
    };
  },
  computed: {
    ...mapActions(["updateSecond"]),
    ...mapGetters([
      "getScheduleList",
      "getProductsForSale",
      "getSelectedBook",
      "getCustomerList",
      "getProductOrderPurchased",
      "getSecond",
    ]),

    orderedProducts() {
      if (!this.selectedSchedule || !this.getProductsForSale.length) return [];
      const gameOrder = this.selectedSchedule.gameOrder || [];
      const productsMap = {};
      this.getProductsForSale.forEach((product) => {
        productsMap[product.id] = product;
      });
      return gameOrder
        .map((item) => productsMap[item.templateId])
        .filter((product) => product);
    },

    totalItemsInReceipt() {
      return this.receitSections.reduce((total, section) => {
        return (
          total + section.items.reduce((sum, item) => sum + item.quantity, 0)
        );
      }, 0);
    },
    AmountDue() {
      let change = parseFloat(this.amountTendered) - this.totalAmount;
      return this.currencyFormat(change > 0 ? change : 0);
    },
    totalAmount() {
      let total = 0;
      this.receitSections.forEach((section) => {
        section.items.forEach((item) => {
          total += item.price;
        });
      });
      return total.toFixed(2);
    },
    DOWNLOAD_URL: () =>
      process.env.VUE_APP_BASE_URL + ENDPOINTS.BOOKS.PRINT_ON_DEMAND_BOOKS,
    totalDueFormatted() {
      return this.currencyFormat(this.totalDue());
    },
    cashTendered() {
      if ("" == this.amountTendered) {
        return this.currencyFormat(0);
      } else {
        return this.currencyFormat(parseFloat(this.amountTendered));
      }
    },
    changeDue() {
      console.log("total due " + this.totalDue);
      let change = this.amountTendered - this.totalDue();
      return this.currencyFormat(change > 0 ? change : 0);
    },
    formattedNumber() {
      return this.number < 10 ? `0${this.number}` : this.number;
    },
    canAddToCart() {
      return (
        this.selectedSchedule &&
        this.getProductsForSale.some((product) => this.itemCount(product) > 0)
      );
    },
    formattedDate() {
      return new Date().toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    selectedScheduleTitle() {
      return this.selectedSchedule?.title || "POS New Design";
    },
    allReceiptItems() {
      return this.receitSections.flatMap((section) =>
        section.items.map((item, itemIndex) => ({
          ...item,
          unitPrice: item.price / item.quantity,
          sectionId: section.id,
          itemIndex,
        }))
      );
    },
  },
  methods: {
    ...mapActions([
      "fetchUpcoming",
      "fetchProductsForSchedule",
      "fetchBooksById",
      "fetchBookById",
      "fetchCustomers",
      "posPurchase",
      "purchasePrint",
      "printSalesReceipt",
      "setCurrentPage",
    ]),
    clearReceipt() {
      this.cartItems = [];
    },
    toggleGameSelection(product) {
      if (this.wouldExceedMaxItems(1)) {
        this.showLimitWarning = true;
        this.showCheckoutLimitWarning = true;
        this.$vm.$snackbar({
          message: `Cannot add item. Maximum limit of ${this.maxItems} items reached.`,
          mode: CONST.THEME.COLOURS.ERROR,
        });
        return;
      }
      this.showLimitWarning = false;
      this.showCheckoutLimitWarning = false;
      this.selectedGames = {
        ...this.selectedGames,
        [product.id]: true,
      };
      this.addSingleProductToReceipt(product);
    },
    wouldExceedMaxItems(additionalQuantity) {
      return this.totalItemsInReceipt + additionalQuantity > this.maxItems;
    },
    calculateTotalPrice() {
      let totalPrice = 0;
      this.orderedProducts.forEach((product) => {
        if (this.selectedGames[product.id]) {
          totalPrice += product.price;
        }
      });
      return totalPrice.toFixed(2);
    },

    updatePriceOnSelection() {
      this.updateTotalDue();
    },

    clearSelectedItems() {
      this.products = this.getProductsForSale.map((product) => ({
        id: product.id,
        quantity: 1,
        doublePrice: product.doublePrice,
      }));
      this.number = 0;
      this.books = [];
      this.booksInPackage = [];
      this.booksNotInPackage = [];
      this.amountTendered = "";
      this.selectedGames = {};
      this.initializeSelectedGames();
    },
    initializeSelectedGames() {
      this.selectedGames = {};
      this.selectedGames = this.getProductsForSale.reduce((acc, product) => {
        return { ...acc, [product.id]: false };
      }, {});
    },

    deleteReceitItem(sectionId, itemIndex) {
      const section = this.receitSections.find((s) => s.id === sectionId);
      if (section) {
        const deletedItem = section.items[itemIndex];
        const productId = deletedItem.productIds[0].id;

        section.items.splice(itemIndex, 1);
        if (section.items.length === 0) {
          this.receitSections = this.receitSections.filter(
            (s) => s.id !== sectionId
          );
        }

        this.selectedGames = {
          ...this.selectedGames,
          [productId]: false,
        };

        if (this.totalItemsInReceipt <= this.maxItems) {
          this.showLimitWarning = false;
          this.showCheckoutLimitWarning = false;
        }
      }
    },
    handleQuantityKeydown(event) {
      if (
        !/[0-9]/.test(event.key) &&
        event.key !== "Backspace" &&
        event.key !== "Delete" &&
        event.key !== "ArrowLeft" &&
        event.key !== "ArrowRight"
      ) {
        event.preventDefault();
      }
    },

    validateReceiptQuantity(event, item) {
      let value = event.target.innerText;

      if (!/^\d+$/.test(value)) {
        event.target.innerText = item.quantity;
        return;
      }

      const quantity = parseInt(value, 10);

      if (quantity < 1) {
        event.target.innerText = 1;
        return;
      }

      if (quantity > this.maxItems) {
        this.showCheckoutLimitWarning = true;
        event.target.innerText = item.quantity;
        this.$vm.$snackbar({
          message: `Cannot set quantity. Maximum limit is ${this.maxItems}.`,
          mode: CONST.THEME.COLOURS.ERROR,
        });
        return;
      }

      const quantityDifference = quantity - item.quantity;
      if (this.totalItemsInReceipt + quantityDifference > this.maxItems) {
        this.showCheckoutLimitWarning = true;
        event.target.innerText = item.quantity;
        this.$vm.$snackbar({
          message: `Cannot set quantity. Maximum limit of ${this.maxItems} items would be exceeded.`,
          mode: CONST.THEME.COLOURS.ERROR,
        });
        return;
      }

      this.showCheckoutLimitWarning = false;

      const section = this.receitSections.find((s) => s.id === item.sectionId);
      if (section) {
        const originalItem = section.items[item.itemIndex];
        if (originalItem) {
          const originalQuantity = originalItem.quantity;
          originalItem.quantity = quantity;
          const unitPrice = originalItem.price / originalQuantity;
          originalItem.price = unitPrice * quantity;
          if (originalItem.productIds) {
            originalItem.productIds.forEach((product) => {
              product.quantity = Math.round(
                (product.quantity / originalQuantity) * quantity
              );
            });
          }
        }
      }
    },

    increaseQuantity(receitSectionId, itemIndex) {
      const receitSection = this.receitSections.find(
        (section) => section.id === receitSectionId
      );

      if (!receitSection) return;

      const item = receitSection.items[itemIndex];
      if (this.totalItemsInReceipt + 1 > this.maxItems) {
        this.showCheckoutLimitWarning = true;
        this.$vm.$snackbar({
          message: `Cannot increase quantity. Maximum limit of ${this.maxItems} items reached.`,
          mode: CONST.THEME.COLOURS.ERROR,
        });
        return;
      }

      this.showLimitWarning = false;
      this.showCheckoutLimitWarning = false;

      const originalQuantity = item.quantity;
      item.quantity += 1;

      const unitPrice = item.price / originalQuantity;
      item.price = unitPrice * item.quantity;

      item.productIds.forEach((product) => {
        product.quantity = Math.round(
          (product.quantity / originalQuantity) * item.quantity
        );
      });
    },

    decreaseQuantity(receitSectionId, itemIndex) {
      const receitSection = this.receitSections.find(
        (section) => section.id === receitSectionId
      );
      if (receitSection) {
        const item = receitSection.items[itemIndex];
        if (item.quantity > 1) {
          const originalQuantity = item.quantity;
          item.quantity -= 1;

          const unitPrice = item.price / originalQuantity;
          item.price = unitPrice * item.quantity;

          item.productIds.forEach((product) => {
            product.quantity = Math.round(
              (product.quantity / originalQuantity) * item.quantity
            );
          });

          if (this.totalItemsInReceipt <= this.maxItems) {
            this.showLimitWarning = false;
            this.showCheckoutLimitWarning = false;
          }
        }
      }
    },
    closeDialog() {
      this.showDialog = false;
    },
    closeNoWinningsDialog() {
      this.showNoWinningsDialog = false;
    },
    itemCount(product) {
      if (!product) return 0;

      let count = 1;

      let matchedBooks = this.booksNotInPackage.filter(
        (book) => product.productTemplateDto.id == book.productTemplateDto.id
      );
      if (matchedBooks != null) {
        count += matchedBooks.length;
      }

      let matchedProducts = this.products.filter(
        (p) => p.id == product.id && p.doublePrice == product.doublePrice
      );
      if (matchedProducts.length > 0) {
        count = matchedProducts[0].quantity;
      }

      if (this.$refs.quantitySpans && this.$refs.quantitySpans[0]) {
        this.$refs.quantitySpans[0].innerText = count;
      }

      return count;
    },

    onDecode(result) {
      console.log(result);
      if (!this.checkCustomers(result) && !this.items.includes(result)) {
        this.fetchBookById(result);
      }
    },
    checkCustomers(scannedID) {
      let found = false;
      let matchedRows = this.getCustomerList.filter(
        (customer) => scannedID == customer.barCodeId
      );
      if (matchedRows.length > 0) {
        this.selectedCustomer = matchedRows[0];
        found = true;
      }
      matchedRows = this.getCustomerList.filter(
        (customer) => scannedID == customer.id
      );
      if (matchedRows.length > 0) {
        this.selectedCustomer = matchedRows[0];
        found = true;
      }

      return found;
    },
    cardClickEvent(product) {
      if (
        this.wouldExceedMaxItems(1) ||
        this.itemCount(product) + 1 > this.maxItems
      ) {
        this.showLimitWarning = true;
        this.$vm.$snackbar({
          message: `Cannot add item. Maximum limit of ${this.maxItems} items reached.`,
          mode: CONST.THEME.COLOURS.ERROR,
        });
        return;
      }
      this.showLimitWarning = false;
      this.showCheckoutLimitWarning = false;
      document.activeElement.blur();

      product.doublePrice
        ? this.items.push(product.id + ":double")
        : this.items.push(product.id);
      let matchedRows = this.products.filter(
        (p) => p.id == product.id && p.doublePrice == product.doublePrice
      );
      if (matchedRows[0] != null) {
        matchedRows[0].quantity++;
      } else {
        this.products.push({
          id: product.id,
          quantity: 1,
          doublePrice: product.doublePrice,
        });
      }

      console.log("products = " + this.products[0].quantity);
    },
    keyPadEvent(keyCode) {
      if ("DEL" == keyCode) {
        this.amountTendered = this.amountTendered.slice(0, -1);
      } else if ("." == keyCode) {
        const result = this.amountTendered.split(/[.]/);
        if (result.length == 1) {
          this.amountTendered = this.amountTendered + keyCode;
        }
      } else {
        const result = this.amountTendered.split(/[.]/);
        if (result.length == 2) {
          if (result[1].length < 2) {
            this.amountTendered = this.amountTendered + keyCode;
          }
        } else {
          this.amountTendered = this.amountTendered + keyCode;
        }
      }
    },

    totalDue() {
      const mainProduct = this.getProductsForSale[0];
      const quantity = this.itemCount(mainProduct);
      let total = this.calculateTotalPrice() * quantity;
      return total;
    },
    async proceedToSale(dispatch) {
      this.showLimitWarning = false;
      this.showCheckoutLimitWarning = false;
      if (this.receitSections.length === 0) {
        this._vm.$snackbar(
          {
            message: "Please add items to cart before proceeding.",
            mode: CONST.THEME.COLOURS.ERROR,
          },
          dispatch
        );
        return;
      }

      let productOrderModel = {
        email: this.selectedCustomer ? this.selectedCustomer.email : null,
        purchaseConfirmationId: Math.floor(Math.random() * 100000000),
        productsOrdered: [],
        amountReceived: this.cashTendered || 0,
        changeDue: this.AmountDue || 0,
      };

      this.receitSections.forEach((section) => {
        section.items.forEach((item) => {
          item.productIds.forEach((product) => {
            productOrderModel.productsOrdered.push({
              productId: product.id,
              quantity: product.quantity,
              isDouble: false,
              scheduleId: this.selectedSchedule?.id || null,
            });
          });
        });
      });

      this.isProcessing = true;
      try {
        await this.posPurchase(productOrderModel);
        const receiptModel = await this.purchasePrint({
          ...productOrderModel,
          receiptId: this.receiptId,
        });
        await this.printSalesReceipt(receiptModel.data);
        await new Promise((resolve) => setTimeout(resolve, 3000));
            this.amountTendered = "";
        this.receitSections = [];
        this.selectedGames = {};
        this.updateSecond(false);
        this.proceedsecondComponent = false;
      } catch (error) {
        console.error("Purchase failed:", error);
      } finally {
        this.isProcessing = false;
        this.showSecond();
      }
    },
    clear() {
      this.$store.dispatch("updateSecond", false);
      this.amountTendered = "";
      this.items = [];
      this.books = [];
      this.products = [];
      this.booksInPackage = [];
      this.booksNotInPackage = [];
      this.selectedCustomer = null;
      this.proceed = false;
      this.showLimitWarning = false;
      this.showCheckoutLimitWarning = false;
      let packages = this.getProductsForSale.filter(
        (product) => product.productTemplateDto.packaged
      );
      for (let i = 0; i < packages.length; i++) {
        let packageProduct = packages[i];
        packageProduct.count = 0;
      }
    },
    currencyFormat(value) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR",
      });

      return formatter.format(value);
    },
    buyItems() {
      let productOrderModel = {
        email: this.selectedCustomer ? this.selectedCustomer.email : null,
        purchaseConfirmationId: Math.floor(Math.random() * 100000000),
        productsOrdered: [],
      };
      for (let i = 0; i < this.books.length; i++) {
        let book = this.books[i];
        let matchedRows = this.getProductsForSale.filter(
          (product) =>
            product.productTemplateDto.id == book.productTemplateDto.id
        );
        let purchaseProductModel = {
          bookId: book.id,
          productId: matchedRows[0].id,
        };
        productOrderModel.productsOrdered.push(purchaseProductModel);
      }
      for (let i = 0; i < this.products.length; i++) {
        let product = this.products[i];
        console.log("product = " + product);
        let purchaseProductModel = {
          productId: product.id,
          quantity: product.quantity,
          isDouble: product.doublePrice ? true : false,
        };
        productOrderModel.productsOrdered.push(purchaseProductModel);
      }
      console.log("productOrderModel", JSON.stringify(productOrderModel));
      this.posPurchase(productOrderModel);
      this.proceed = false;
      this.clear();
    },
    increase() {
      this.number++;
    },

    addSingleProductToReceipt(product) {
      const quantity = 1;

      const totalItemsAfterAdd = this.totalItemsInReceipt + quantity;
      if (totalItemsAfterAdd > this.maxItems) {
        this.showLimitWarning = true;
        this.$vm.$snackbar({
          message: `Cannot add more items. Maximum limit of ${this.maxItems} items reached.`,
          mode: CONST.THEME.COLOURS.ERROR,
        });
        return;
      }

      this.showLimitWarning = false;

      let existingItem = null;
      for (const section of this.receitSections) {
        if (section.items[0].selectionKey === product.id.toString()) {
          existingItem = section.items[0];
          break;
        }
      }
      if (existingItem) {
        existingItem.quantity += quantity;
        existingItem.price += product.price * quantity;
        existingItem.productIds[0].quantity += quantity;
      } else {
        const price = product.price * quantity;
        const productId = {
          id: product.id,
          quantity: quantity,
        };

        const receiptItem = {
          game: product.productTemplateDto.title,
          quantity: quantity,
          price: price,
          productIds: [productId],
          date: this.selectedSchedule?.date || new Date().toISOString(),
          scheduleTitle:
            this.selectedSchedule?.title || product.productTemplateDto.title,
          isPackaged: product.productTemplateDto.packaged,
          selectionKey: product.id.toString(),
          templateOrder: this.getTemplateOrder(product.id), // Store template order
        };

        const newReceitSection = {
          id: Date.now(),
          gameDate: new Date().toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
          gameText:
            this.selectedSchedule?.title || product.productTemplateDto.title,
          items: [receiptItem],
          templateOrder: receiptItem.templateOrder,
        };

        this.receitSections.push(newReceitSection);
        this.receitSections.sort((a, b) => a.templateOrder - b.templateOrder);
      }
    },
    getTemplateOrder(productId) {
      if (!this.orderedProducts) return 0;
      const index = this.orderedProducts.findIndex((p) => p.id === productId);
      return index >= 0 ? index : 0;
    },

    insertSectionInOrder(newSection) {
      let insertIndex = this.receitSections.length;
      for (let i = 0; i < this.receitSections.length; i++) {
        if (newSection.templateOrder < this.receitSections[i].templateOrder) {
          insertIndex = i;
          break;
        }
      }
      this.receitSections.splice(insertIndex, 0, newSection);
    },
    removeProductFromReceipt(product) {
      this.receitSections = this.receitSections.filter(
        (section) => section.items[0].selectionKey !== product.id.toString()
      );
    },

    decrease(product) {
      const matchedProduct = this.products.find(
        (p) => p.id === product.id && p.doublePrice === product.doublePrice
      );

      if (matchedProduct && matchedProduct.quantity > 1) {
        matchedProduct.quantity--;

        if (matchedProduct.quantity === 0) {
          this.products = this.products.filter(
            (p) => p.id !== product.id || p.doublePrice !== product.doublePrice
          );
        }
        if (this.selectedGames[product.id]) {
          this.addSingleProductToReceipt(product);
        }
      }
    },
    removeItem(index) {
      this.cartItems.splice(index, 1);
    },
    showSecond() {
      this.showLimitWarning = false;
      this.showCheckoutLimitWarning = false;
      const newValue = !this.getSecond;
      this.$store.dispatch("updateSecond", newValue);
      this.componentKey += 1;
    },

    addToCart() {
      const selectedProducts = this.getProductsForSale.filter(
        (product) => this.itemCount(product) > 0
      );
      selectedProducts.forEach((product) => {
        const quantity = this.itemCount(product);
        const price = product.doublePrice
          ? product.doublePrice * quantity
          : product.price * quantity;
        const existingItem = this.cartItems.find(
          (item) =>
            item.game === product.productTemplateDto.title &&
            item.date === this.selectedSchedule.date
        );

        if (existingItem) {
          existingItem.quantity += quantity;
          existingItem.price += price;
        } else {
          const cartItem = {
            game: product.productTemplateDto.title,
            quantity: quantity,
            price: price,
            date: this.selectedSchedule.date,
            scheduleTitle: product.scheduleDto.title,
          };
          this.cartItems.push(cartItem);
        }
      });

      this.products = [];
      this.number = 0;
      this.books = [];
      this.booksInPackage = [];
      this.booksNotInPackage = [];
      this.amountTendered = "";
    },
    clearCart() {
      this.cartItems = [];
      this.amountTendered = "";
      this.selectedCustomer = null;
      this.number = 0;
      this.products = [];
      this.books = [];
      this.booksInPackage = [];
      this.booksNotInPackage = [];
    },

    validateQuantity(event, product) {
      let value = event.target.innerText;
      const matchedProduct = this.products.find(
        (p) => p.id === product.id && p.doublePrice === product.doublePrice
      );

      if (!/^\d+$/.test(value)) {
        matchedProduct.quantity = 1;
        event.target.innerText = this.itemCount(product);
        this.showLimitWarning = false;
        this.showCheckoutLimitWarning = false;
        return;
      }

      const quantity = parseInt(value, 10);
      const currentProductQuantity = matchedProduct
        ? matchedProduct.quantity
        : 0;
      const quantityDifference = quantity - currentProductQuantity;

      if (
        this.wouldExceedMaxItems(quantityDifference) ||
        quantity > this.maxItems
      ) {
        this.showLimitWarning = true;
        this.showCheckoutLimitWarning = true;
        event.target.innerText = this.itemCount(product);
        this.$vm.$snackbar({
          message: `Cannot set quantity. Maximum limit of ${this.maxItems} items would be exceeded.`,
          mode: CONST.THEME.COLOURS.ERROR,
        });
        return;
      }

      this.showLimitWarning = false;
      if (matchedProduct) {
        matchedProduct.quantity = quantity;
      } else {
        this.products.push({
          id: product.id,
          quantity: quantity,
          doublePrice: product.doublePrice,
        });
      }

      this.updateTotalDue();
      if (this.selectedGames[product.id]) {
        this.addSingleProductToReceipt(product);
      }
    },
    updateTotalDue() {
      this.totalDueFormatted = this.currencyFormat(this.totalDue());
    },
  },
  async mounted() {
    this.isLoading = true;
    this.$store.dispatch("updateSecond", false);
    try {
      await this.fetchUpcoming();
      const scheduleId = this.$route.params.scheduleId;
      const schedules = this.getScheduleList.filter((s) => s.id == scheduleId);
      this.selectedSchedule = schedules[0] || null;
      if (this.selectedSchedule) {
        await this.fetchProductsForSchedule(this.selectedSchedule.id);
        this.products.push({
          id: this.getProductsForSale[0]?.id,
          quantity: 1,
          doublePrice: this.getProductsForSale[0]?.doublePrice,
        });
        this.initializeSelectedGames();
      }
      this.setCurrentPage("Sales");
      this.updateTotalDue();
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      this.isLoading = false;
    }
  },
  watch: {
    selectedSchedule(schedule) {
      if (schedule) {
        this.fetchProductsForSchedule(schedule.id);
        document.activeElement.blur();
      }
    },
    getProductOrderPurchased(productOrderPurchased) {
      this.receiptId = productOrderPurchased.receiptId;

      printJS({
        printable:
          this.DOWNLOAD_URL + productOrderPurchased.purchaseConfirmationId,
        type: "pdf",
        showModal: true,
        onLoadingEnd: () => {
          setTimeout(() => {}, 500);
        },
      });
      // const url = `http://localhost:8082/print-pdf?purchaseConfirmationId=${productOrderPurchased.purchaseConfirmationId}`;
      // fetch(url)
      //   .then(() => {
      //     console.log('Ticket Printed Success');
      //   })
      //   .catch(error => {
      //     console.error("Error:", error);
      //   });
    },
    getSelectedBook(newBook) {
      console.log(newBook);
      if (newBook.winnerDtos.length > 0) {
        this.showDialog = true;
        return;
      }
      if (newBook.archived) {
        this.showNoWinningsDialog = true;
        return;
      }
      if (!this.items.includes(newBook.id)) {
        this.items.push(newBook.id);
        this.books.push(newBook);
        this.booksNotInPackage.push(newBook);

        let packages = this.getProductsForSale.filter(
          (product) => product.productTemplateDto.packaged
        );
        for (let i = 0; i < packages.length; i++) {
          let packageProduct = packages[i];
          let packageCompleted = false;
          let booksToRemove = [];
          for (
            let j = 0;
            j < packageProduct.productTemplateDto.children.length;
            j++
          ) {
            let child = packageProduct.productTemplateDto.children[j];
            let matchedRows = [];
            matchedRows = this.booksNotInPackage.filter(
              (book) => child.id == book.productTemplateDto.id
            );
            if (matchedRows.length == child.quantity) {
              booksToRemove.push(...matchedRows);
              console.log(booksToRemove);
              packageCompleted = true;
            } else {
              packageCompleted = false;
            }
          }
          if (packageCompleted) {
            if (packageProduct.count == null) {
              packageProduct.count = 0;
            }
            packageProduct.count++;
            this.booksNotInPackage = this.booksNotInPackage.filter(
              (book) => !booksToRemove.includes(book)
            );
            this.booksInPackage.push(...booksToRemove);
          }
        }
      }
    },
    getProductsForSale() {
      this.initializeSelectedGames();
      if (this.orderedProducts.length > 0) {
        const newSelectedGames = {};
        this.orderedProducts.forEach((product) => {
          newSelectedGames[product.id] =
            this.selectedGames[product.id] !== false;
        });
        this.selectedGames = newSelectedGames;
      }
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap");

.custom-container {
  max-width: 1300px;
}

.titleSpan {
  color: #fff;
  font-family: "PT Sans";
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
}

.logoBox {
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.22);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
}

.logoBoxCal {
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.22);
  padding: 20px;
}

.marginBox {
  margin-top: 15px;
}

.logoBoxValue {
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.22);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 19px;
  max-width: 48%;
  margin-top: 15px;
}

.ticketPriceSpan {
  color: #fcdb04;
  font-family: "PT Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
}

.ticketPriceSpanNumber {
  color: #fff;
  font-family: "PT Sans";
  font-size: 72px;
  font-style: normal;
  font-weight: 400;
  line-height: 80px;
  letter-spacing: 0.1px;
}

.ticketPriceSpanNumber.quantitySpan {
  max-width: 170px;
  outline: none;
  padding: 0px 10px;
  border-radius: 24px;
  min-width: 130px;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.1) !important;
  overflow: hidden;
  white-space: nowrap;
}

.receitQuantityspan {
  overflow: hidden;
  min-width: 70px;
  max-width: 70px;
  white-space: nowrap;
  text-align: center;
}

.minus-box {
  background-color: rgba(255, 255, 255, 0.13);
  width: 35px;
  height: 29px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.plus-box {
  background-color: #fcdb04;
  width: 35px;
  height: 29px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.totalDueAmountCol {
  color: #fff;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  padding: 17px 0px;
}

.calBtn {
  border-radius: 24px !important;
  background: rgba(255, 255, 255, 0.1) !important;
  display: flex !important;
  height: 80px !important;
  padding: 12px !important;
  justify-content: center !important;
  align-items: center !important;
  box-shadow: none !important;
  width: 98% !important;
  color: #fff !important;
  text-align: center !important;
  font-family: "PT Sans" !important;
  font-size: 32px !important;
  font-style: normal !important;
  font-weight: 400 !important;
}

.gameCardBase {
  min-height: 111px;
  max-height: 111px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cashCal {
  color: #fff;
  text-align: right;
  font-family: "PT Sans";
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.addToCartBtn {
  border-radius: 4px;
  background: #fcdb04;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #525252;
  border: 1px solid #fcdb04;
  text-align: center;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 100%;
}

.addToCartBtn:hover {
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.11);
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.11);
  text-align: center;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 100%;
}

.testGameCol {
  color: #fff;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
}

.quantityCol {
  color: #fff;
  font-family: "PT Sans";
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 5px;
}

.quantityValueCol {
  color: #fcdb04;
  font-family: "PT Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}

.logoBoxDelete {
  width: 74px;
  height: 54px;
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #725291;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.clearBtn {
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.26);
  display: flex;
  width: 250px;
  padding: 13px 0px 12px 0px;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.25px;
  text-transform: uppercase;
}

.absolute-center {
  width: 90px;
}

.btnsRow {
  padding: 0px 20px 20px 20px;
}

::v-deep .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  border-radius: 7px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: rgba(255, 255, 255, 0.22) !important;
  box-shadow: none !important;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border-radius: 7px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: rgba(255, 255, 255, 0.22) !important;
  box-shadow: none !important;
}

::v-deep .theme--light.v-icon {
  color: #fff;
}

::v-deep .theme--light.v-input input {
  color: #fff;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
}

::v-deep .theme--light.v-label {
  color: #fff;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
}

.btnsGroup {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 20px 0px;
}

/* Style for selected item in dropdown */
:deep(.v-select__selection) {
  color: #000 !important;
  background-color: #fcdb04 !important;
  padding: 2px 8px !important;
  border-radius: 4px !important;
}

/* Style for the dropdown items when menu is open */
:deep(.v-list-item--active) {
  background-color: #fcdb04 !important;
  color: #000 !important;
}

:deep(.v-list-item--active .v-list-item__title) {
  color: #000 !important;
}

.calculatorBox {
  margin: 10px 20px;
}

.clearBtn {
  padding: 0px 10px;
  min-width: 170px;
  border-radius: 4px;
}

.completeBtn {
  display: inline-flex;
  padding: 13px 77.75px 12px 78.25px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #fcdb04;
  color: #525252;
  text-align: center;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.25px;
  text-transform: uppercase;
}

.posDropdown {
  padding: 0px 0px 0px 0px;
}

.enterBtn {
  display: flex;
  width: 100%;
  padding: 12px 0px 13px 0px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #eaeaea;
  color: #525252;
  text-align: center;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.25px;
  text-transform: uppercase;
}

.saleText {
  color: #fff;
  font-family: "PT Sans";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.25px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px 0px 20px 0px;
}

.marginPos {
  margin-top: 20px;
}

.receitBox {
  border-radius: 7px;
  border: 1px dashed rgba(255, 255, 255, 0.71);
  background: rgba(255, 255, 255, 0.22);
  min-height: 100%;
  max-height: 438px;
  overflow-y: auto;
}

.receitBoxSecond {
  min-height: 100%;
  max-height: 535px;
}

.staffText {
  color: #fff;
  font-family: "PT Sans";
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.45);
  border-bottom: 1px solid rgba(255, 255, 255, 0.45);
  padding: 10px 30px;
}

.gameBox {
  display: flex;
  flex-direction: column;
  font-family: "PT Sans";
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  /* 145.455% */
  letter-spacing: 0.25px;
}

.gameText {
  color: #fcdb04;
}

.tableBox {
  margin-top: 10px;
}

.tableRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.45);
  padding: 9px 0px;
  gap: 10px;
}

.qtyBox {
  display: flex;
  align-items: center;
}

.qtyInput {
  width: 70px;
  height: 33px;
  flex-shrink: 0;
  margin-right: 3px;
  border-radius: 6px;
  border: 1px solid #fff;
  padding: 0px 3px;
}

.logoBoxMain {
  display: flex;
  justify-content: space-between;
}

.icons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.gameDate {
  padding-top: 32px;
  display: flex;
  justify-content: space-between;
}

.contentRow {
  border-bottom: 1px solid rgba(255, 255, 255, 0.45);
}

.receitSection {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.receitBlock {
  display: flex;
  flex-direction: column;
  /* gap: 15px; */
  justify-content: space-between;
}

.subTotalBtn {
  border-radius: 4px;
  background: #fcdb04;
  display: inline-flex;
  padding: 12px 50px 13px 50px;
  justify-content: center;
  align-items: center;
  color: #525252;
  text-align: center;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  max-width: 260px;
}

.subTotalColumn {
  display: flex;
  justify-content: end;
}

.minusBtn,
.plusBtn {
  height: 18px;
  display: flex;
  justify-content: start;
  align-items: start;
  cursor: pointer;
}

.receitdeleteBtn {
  cursor: pointer;
}

.header {
  font-size: 22px;
}

.billBlockMain {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 1px 13px 0px 6px;
}

.totalAmountColumn {
  display: flex;
  justify-content: space-between;
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.22);
  padding: 14px !important;

  font-family: "PT Sans";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  /* 91.667% */
  letter-spacing: 0.1px;
}

.posSectionRow {
  padding-top: 20px;
}

.receitBlockSecond {
  padding: 0px 12px 0px 0px;
}

.totalTitle {
  color: #fcdb04;
}

.gamePrice {
  color: #fcdb04;
  text-align: right;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}

.gameName {
  color: #fff;
  font-family: "PT Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}

.totalAmountdisplay {
  display: flex;
  flex-direction: column !important;
  gap: 20px;
  justify-content: center;
  align-items: center;
  padding: 41px 35px;
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.22);
  font-family: "PT Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.1px;
}

.displayAmountRow {
  display: flex;
  gap: 10px;
  flex-direction: row;
  padding-right: 10px;
}

.priceAmount {
  font-size: 32px !important;
}

.calculatorSection {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.logoBoxPOS {
  min-height: 100px;
  display: flex;
  flex-direction: column;
}

.tableRow span,
.qtyBox {
  /* flex: 1; */
  width: 20%;
  text-align: left;
  /* display: flex; */
  align-items: center;
  justify-content: flex-start;
}

.nameColumn {
  width: 40% !important;
}

.nameColumnHeader {
  width: 40% !important;
}

.MainComponent {
  margin: 10px 16px 1px 10px;
}

.totalColumnRow {
  padding: 20px 10px 20px 0px;
}

.receitQuantityspan {
  display: flex !important;
  justify-content: center !important;
}

.gameDropdown {
  background-image: url(../../assets/chevron.svg);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 12px 6px;
  cursor: pointer;
}

.gameDropdown::after {
  content: "";
  position: absolute;
  right: 40px;
  top: 45%;
  transform: translateY(-50%);
  height: 30px;
  width: 1px;
  background-color: #d9d9d923;
}

.newDisplay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 6px 0px !important;
  height: 100%;
}

.dueSpanText {
  color: #fcdb04;
  max-height: 10px !important;
  overflow: hidden;
}

.duePrice,
.priceAmount {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.priceAmount {
  text-align: center;
}

.plus-box,
.minus-box,
.btnsGroup button {
  user-select: none;
}

.limitWarning {
  font-size: 14px;
  color: rgb(240, 88, 88);
  margin-bottom: 0;
}

.priceBox {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px !important;
}

.gameTicketPrice {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 240px !important;
}

.v-overlay {
  z-index: 9999 !important;
}

.v-progress-circular {
  color: #323887 !important;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 10px;
}

.gameInfo {
  height: 42px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.45);
  padding: 5px 0px;
}

.logoImage {
  padding: 10px;
}

.productLogos {
  padding: 0px;
}

@media screen and (max-width: 2000px) {
  .gameDate {
    padding-top: 15px;
  }

  .saleText {
    padding: 0px 0px 12px 0px;
  }

  .staffText {
    padding: 6px 30px;
  }

  .receitBoxSecond {
    min-height: 100%;
    max-height: 500px;
  }

  .calBtn {
    height: 70px !important;
    padding: 12px !important;
  }

  .totalAmountdisplay {
    padding: 15px 35px;
    line-height: 28px !important;
  }

  .custom-container {
    padding-top: 0px;
  }
}

@media screen and (max-width: 1600px) {
  .logoBoxValue {
    padding: 10px;
    margin-top: 15px;
  }

  .receitBox {
    min-height: 100%;
    max-height: 438px;
  }

  .receitBoxSecond {
    min-height: 100%;
    max-height: 500px;
  }

  .calBtn {
    height: 50px !important;
    padding: 12px !important;
  }

  .totalAmountdisplay {
    padding: 15px 35px;
    line-height: 28px !important;
  }

  .custom-container {
    padding-top: 0px;
  }
}

/* 90% screen resolution*/
@media screen and (max-width: 1500px) {
  .logoBox {
    padding: 0px 12px !important;
  }

  .posDropdown {
    padding: 5px 0px 0px 0px;
  }

  .logoBoxValue {
    margin-top: 15px;
  }

  .logoBoxPOS {
    min-height: 80px;
  }

  .ticketPriceSpanNumber.quantitySpan {
    border-radius: 12px;
  }

  .receitBox {
    min-height: 100%;
    max-height: 438px;
  }

  .receitBoxSecond {
    min-height: 100%;
    max-height: 435px;
  }

  .totalColumnRow {
    padding: 10px 10px 0px 0px;
  }

  .btnsGroup {
    padding: 10px 0px;
  }

  .posSectionRow {
    padding-top: 10px;
  }

  .calculatorSection {
    gap: 10px;
  }

  .totalAmountdisplay {
    gap: 12px;
    line-height: 24px !important;
  }

  .cashCal {
    padding: 0px 12px;
  }

  .calBtn {
    border-radius: 12px !important;
  }

  .newDisplay {
    padding: 15px 0px !important;
  }

  .duePrice,
  .priceAmount {
    padding-top: 5px;
    height: 30px;
  }
}

/* 100% screen resolution*/
@media screen and (max-width: 1400px) {
  .ticketPriceSpanNumber {
    font-size: 40px;
    line-height: 45px;
  }

  .logoBox {
    padding: 0px 12px !important;
  }
  .marginBox {
    margin-top: 15px !important;
  }

  .logoBoxPOS {
    min-height: 60px;
  }

  .ticketPriceSpanNumber.quantitySpan {
    border-radius: 12px;
  }

  .receitBox {
    min-height: 100%;
    max-height: 400px;
  }

  .receitBoxSecond {
    min-height: 100%;
    max-height: 400px;
  }

  .priceAmount {
    font-size: 25px !important;
  }

  .totalAmountdisplay {
    padding: 10px 35px;
  }

  .logoBoxCal {
    padding: 10px !important;
  }

  .cashCal {
    font-size: 32px;
    padding: 0px 12px;
  }

  .completeBtn {
    padding: 6px 77px 6px 78px;
  }

  .totalColumnRow {
    padding: 10px 10px 10px 0px;
  }

  .card {
    margin-top: 10px !important;
  }

  .duePrice,
  .priceAmount {
    height: unset;
    padding-bottom: 10px;
    padding-top: 0px;
  }
}

@media screen and (max-width: 768px) {
  .logoBoxValue {
    max-width: 100%;
  }

  .logoBoxMain {
    flex-direction: column;
  }

  .enterBtn {
    margin-bottom: 20px !important;
  }

  .MainComponent {
    margin: 10px;
  }

  .billBlockMain {
    padding: 5px;
  }

  .receitBlockSecond {
    padding: 0px;
  }

  .calculatorSection {
    padding-top: 10px !important;
  }

  .totalColumnRow {
    padding: 10px 0px;
  }

  .completeBtn,
  .clearBtn {
    max-width: 120px;
  }

  .btnsGroup {
    justify-content: center;
    padding: 10px 0px !important;
  }

  .displayAmountRow {
    display: flex;
    flex-direction: column !important;
    padding-right: 0px;
  }

  .calculatorSection {
    height: 100%;
  }
}
.selected-game {
  border: 1px solid #ffd700;
  box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
}

.logoBox {
  cursor: pointer;
  transition: all 0.3s ease;
}
</style>
<style>
.v-application .primary--text {
  color: #ffffff !important;
  caret-color: #ffffff !important;
}
</style>
